import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// Categorías de gasto administrables por negocio. Si el negocio no tiene
// ninguna, siembra las de por defecto (asegurar_categorias_gasto).
export async function obtenerCategoriasGasto() {
  const neg = getNegocioId();
  let { data, error } = await supabase
    .from('categorias_gasto').select('*').eq('negocio_id', neg).order('orden', { ascending: true });
  if (error) throw error;
  if (!data || data.length === 0) {
    await supabase.rpc('asegurar_categorias_gasto', { p_negocio_id: neg });
    const r = await supabase.from('categorias_gasto').select('*').eq('negocio_id', neg).order('orden', { ascending: true });
    data = r.data || [];
  }
  return data;
}

export async function crearCategoriaGasto(nombre) {
  const neg = getNegocioId();
  const { data: max } = await supabase
    .from('categorias_gasto').select('orden').eq('negocio_id', neg).order('orden', { ascending: false }).limit(1).maybeSingle();
  const { data, error } = await supabase
    .from('categorias_gasto')
    .insert([{ negocio_id: neg, nombre: nombre.trim(), orden: (max?.orden || 0) + 1 }])
    .select().single();
  if (error) throw error;
  return data;
}

export async function renombrarCategoriaGasto(id, nombre) {
  const { error } = await supabase.from('categorias_gasto').update({ nombre: nombre.trim() }).eq('id', id);
  if (error) throw error;
}

export async function eliminarCategoriaGasto(id) {
  const { error } = await supabase.from('categorias_gasto').delete().eq('id', id);
  if (error) throw error;
}
